import { Card, List, Text } from '@mantine/core';

interface FormErrorsSummaryProps {
  /** Заголовок сводки (напр. «Исправьте ошибки в форме»). */
  readonly title: string;
  /** Уже переведённые строки-требования, чего не хватает для отправки. */
  readonly items: readonly string[];
}

// Единая сводка ошибок формы (красная): карточка с красной рамкой/фоном и красным текстом (danger),
// заголовок + список того, чего не хватает. Возвращает null, если ошибок нет. Стиль — как блок формы
// продажи, но в красных тонах (единый вид на всех формах: продажа, прайс и т.п.).
export default function FormErrorsSummary({ title, items }: FormErrorsSummaryProps) {
  if (items.length === 0) {
    return null;
  }
  return (
    <Card withBorder padding="md" bg="red.0" style={{ borderColor: 'var(--mantine-color-red-3)' }}>
      <Text size="sm" fw={500} c="red.7" mb={6}>
        {title}
      </Text>
      <List size="sm" c="red.7">
        {items.map((item) => (
          <List.Item key={item}>{item}</List.Item>
        ))}
      </List>
    </Card>
  );
}
